import firebase from 'firebase/app';
import "firebase/auth";
import "firebase/storage";
import "firebase/database";
import "firebase/functions";



const config = {
  apiKey: "AIzaSyCJDglJKBTMwta1ifgoMtgkW-DVcWBbs28",
  authDomain: "angsklockan-etapp-2.firebaseapp.com",
  databaseURL: "https://angsklockan-etapp-2.firebaseio.com",
  projectId: "angsklockan-etapp-2",
  storageBucket: "angsklockan-etapp-2.appspot.com",
  messagingSenderId: "342260954489",
  appId: "1:342260954489:web:a604df2b3d98f100c16ba8",
  measurementId: "G-KZXJ94EN7J"
};

var fire = firebase.initializeApp(config);
export default fire;
